export const routeConstants = {
  ROOT: {
    path: '/'
  },
  LOGIN: {
    path: '/login',
    name: 'login',
    title: 'Login'
  },
  LOGOUT: {
    path: '/logout',
    name: 'logout',
    title: 'Logging out...'
  },
  STUDYPAGES_LOGIN_SUCCESS: {
    path: '/studypages/success',
    name: 'studypage-success',
    title: 'Signing In...'
  },
  STUDY_REDIRECT: {
    path: '/investigation/:studyId',
    name: 'study-redirect',
    title: 'Redirecting...'
  },
  ECONSENT_VERIFICATION: {
    path: '/e-consent-verification',
    name: 'eConsent-redirect',
    title: 'Redirecting...'
  },
  JOIN_STUDY: {
    path: '/join',
    name: 'join-study',
    title: 'Join Study'
  },
  SIGNUP: {
    path: '/signup',
    name: 'signup',
    title: 'Sign Up'
  },
  ONBOARDING: {
    path: '/onboarding',
    name: 'onboarding',
    title: 'Onboarding'
  },
  PUBLIC_FORM: {
    path: '/form/:formIdentifier',
    name: 'publicForm',
    title: 'Entry'
  },
  PRINT_FORM: {
    path: '/form/:formIdentifier/print',
    name: 'printForm',
    title: 'Print Form'
  },
  DASHBOARD: {
    path: '/dash',
    name: 'dashboardContainer'
  },
  DATA: {
    path: 'data',
    name: 'data',
    title: 'Data'
  },
  ARCHIVE: {
    path: 'archive',
    name: 'archive',
    title: 'Archive'
  },
  FORMS: {
    path: 'forms',
    name: 'forms',
    title: 'Forms'
  },
  FORM_BUILDER: {
    path: 'form/:identifier',
    name: 'formBuilder',
    title: 'Edit Form'
  },
  CASES: {
    path: 'cases',
    name: 'caseList',
    title: 'Data'
  },
  CASE: {
    path: 'case/:identifier',
    name: 'case',
    title: 'Data'
  },
  CASE_NEW_ENTRY: {
    path: 'form/:formIdentifier/entry/new',
    name: 'caseNewEntry',
    title: 'Data'
  },
  CASE_ENTRY: {
    path: 'form/:formIdentifier/entry/:entryIdentifier',
    name: 'caseEntry',
    title: 'Data'
  },
  CASE_ENTRY_FROM_PIPELINE: {
    path: 'case/:identifier/form/:formIdentifier/entry/:entryIdentifier',
    name: 'caseEntry',
    title: 'Data'
  },
  ENTRIES: {
    path: 'entries',
    name: 'entryList',
    title: 'Data'
  },
  NEW_ENTRY: {
    path: 'form/:formIdentifier/entry/new',
    name: 'newEntry',
    title: 'Data'
  },
  ENTRY: {
    path: 'form/:formIdentifier/entry/:entryIdentifier',
    name: 'entry',
    title: 'Data'
  },
  EXPORT: {
    path: 'export',
    name: 'export',
    title: 'Export'
  },
  ACTIVITY: {
    path: 'activity',
    name: 'activity',
    title: 'Activity'
  },
  ANALYTICS: {
    path: 'analytics',
    name: 'analytics',
    title: 'Analytics'
  },
  MANAGE: {
    path: 'manage',
    name: 'manage',
    title: 'Manage Users'
  },
  STUDY_SETTINGS: {
    path: 'study_settings',
    name: 'studySettings',
    title: 'Study Settings'
  },
  PART_11_PIN_SETUP: {
    path: 'part11pin',
    name: 'part11PinSetup',
    title: 'Part 11 PIN Setup'
  },
  ACCOUNT_SETTINGS: {
    path: 'accountSettings',
    name: 'accountSettings',
    title: 'Account Settings'
  },
  STUDY_CREATE: {
    path: 'studyCreate',
    name: 'studyCreate',
    title: 'Create Study'
  },
  SURGEON_DASHBOARD: {
    path: 'surgeon-dashboard',
    name: 'surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  DEFAULT_SURGEON_DASHBOARD: {
    path: 'surgeon-dashboard',
    name: 'default-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  CASE_SURGEON_DASHBOARD: {
    path: ':caseId',
    name: 'case-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  INTERACTIVE_SURGEON_DASHBOARD: {
    path: ':caseId/interactive',
    name: 'interactive-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  MOBILE_AUTH: {
    path: '/mobile-auth',
    name: 'mobile-auth',
    title: 'Mobile Authentication'
  }
};

export const ADJECTIVES = [
  'neat',
  'crisp',
  'slick',
  'smart',
  'awesome',
  'phenomenal',
  'fabulous',
  'elegant',
  'smooth',
  'creative',
  'imaginative',
  'innovative',
  'inventive',
  'original',
  'inspiring',
  'fanciful',
  'fantastic',
  'whimsical',
  'innovational',
  'fresh',
  'fancy',
  'experimental',
  'chimeric',
  'revolutionary',
  'phantasmic',
  'astute',
  'insightful',
  'inspirational',
  'pioneering',
  'trailblazing',
  'transformational',
  'visionary',
  'bright',
  'intelligent',
  'clever',
  'wise',
  'brainy',
  'brilliant',
  'savvy',
  'canny',
  'crafty',
  'ingenious',
  'genius',
  'keen',
  'knowledgeable',
  'resourceful',
  'exceptional',
  'genial',
  'quick-witted',
  'sharp-witted',
  'nimble',
  'intuitive',
  'masterly',
  'enlightened',
  'thoughtful',
  'masterful'
];

// eslint-disable-next-line no-shadow
export enum DATA_VIEW_FILTER {
  CASES = 'cases',
  ENTRIES = 'entries',
  PIPELINE = 'pipeline'
}

export const DATA_FILTERS = [
  {
    id: 1,
    label: 'Cases',
    value: DATA_VIEW_FILTER.CASES,
    icon: 'folder'
  },
  {
    id: 2,
    label: 'All entries',
    value: DATA_VIEW_FILTER.ENTRIES,
    icon: 'file'
  },
  {
    id: 3,
    label: 'Pipeline',
    value: DATA_VIEW_FILTER.PIPELINE,
    icon: 'bars-progress'
  }
];

//local storage keys
export const DATA_VIEW_FILTER_KEY = 'casesViewFilter';

export const DATE_FORMAT_1 = 'dd MMM yyyy, hh:mm';
export const DATE_FORMAT_2 = 'dd MMM, hh:mm';
export const DATE_FORMAT_3 = 'dd-MMM-yyyy hh:mm';
export const DATE_FORMAT_4 = 'dd-MMM-yyyy';
export const DATE_FORMAT_5 = 'dd-MM-yy hh:mm';
export const DATE_FORMAT_6 = 'dd-MM-yy';
export const DATE_FORMAT_7 = 'HH:mm MM/dd/yy ';

export const DATE_FORMATS = [
  {
    label: 'International Date Formats',
    items: [
      { label: 'yyyy-MM-dd', value: 'yyyy-MM-dd' },
      { label: 'yyyy/MM/dd', value: 'yyyy/MM/dd' },
      { label: 'dd-MM-yyyy', value: 'dd-MM-yyyy' },
      { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
      { label: 'MM-dd-yyyy', value: 'MM-dd-yyyy' },
      { label: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
      { label: 'yyyy.MM.dd', value: 'yyyy.MM.dd' },
      { label: 'dd.MM.yyyy', value: 'dd.MM.yyyy' },
      { label: 'MM.dd.yyyy', value: 'MM.dd.yyyy' },
      { label: 'yyyyMMdd', value: 'yyyyMMdd' },
      { label: 'ddMMyyyy', value: 'ddMMyyyy' },
      { label: 'MMddyyyy', value: 'MMddyyyy' }
    ]
  },
  {
    label: 'Expanded and Abbreviated Formats',
    items: [
      { label: 'MMMM dd, yyyy', value: 'MMMM dd, yyyy' },
      { label: 'MMM dd, yyyy', value: 'MMM dd, yyyy' },
      { label: 'dd MMMM yyyy', value: 'dd MMMM yyyy' },
      { label: 'dd MMM yyyy', value: 'dd MMM yyyy' },
      { label: 'yyyy MMMM dd', value: 'yyyy MMMM dd' },
      { label: 'yyyy MMM dd', value: 'yyyy MMM dd' },
      { label: 'dd MMMM yyyy', value: 'dd MMMM yyyy' },
      { label: 'MMMM dd, yyyy', value: 'MMMM dd, yyyy' }
    ]
  },
  {
    label: 'Compact formats',
    items: [
      { label: 'yyyyMMdd', value: 'yyyyMMdd' },
      { label: 'ddMMyyyy', value: 'ddMMyyyy' },
      { label: 'MMddyyyy', value: 'MMddyyyy' }
    ]
  },
  {
    label: 'Other Regional formats',
    items: [
      { label: 'dd.MM.yyyy', value: 'dd.MM.yyyy' },
      { label: 'yyyy.MM.dd', value: 'yyyy.MM.dd' },
      { label: 'MM.dd.yyyy', value: 'MM.dd.yyyy' },
      { label: 'dd-MM-yy', value: 'dd-MM-yy' },
      { label: 'yy-MM-dd', value: 'yy-MM-dd' },
      { label: 'yy/MM/dd', value: 'yy/MM/dd' }
    ]
  }
];

export const FORM_IMPORT_FIELD_HEADERS = [
  'identifier',
  'type',
  'label',
  'description',
  'conditions',
  'options',
  'default',
  'formulaString',
  'variableName',
  'archivedAt'
];

// DEEP LINK ACTIONS
// eslint-disable-next-line no-shadow
export enum DEEPLINK_ACTIONS {
  NON_USER_JOIN_STUDY='NON-USER/JOIN_STUDY',
  USER_JOIN_STUDY='USER/JOIN_STUDY',
  PUBLIC_LINK_JOIN_STUDY='PUBLIC_LINK/JOIN_STUDY'
}

// eslint-disable-next-line no-shadow
export enum REDIRECTION_ACTIONS {
  ACTION_STUDY_REDIRECT='study-redirect',
  ACTION_MOBILE_LOGIN = 'mobile-redirect',
  ACTION_MOBILE_LOGIN_ANDROID = 'mobile-redirect-android',
  ACTION_MOBILE_LOGIN_SPDATA = 'mobile-redirect-spdata',
  ACTION_MOBILE_LOGIN_PUMP = 'mobile-redirect-pump',
  ACTION_ECONSENT = 'econsent',
  ACTION_JOIN_STUDY = 'join-study'
}

export const GRAPH_TYPES = [
  {
    type: 'bar',
    label: 'Bar - Frequency of a Choice Field',
    icon: {
      icon: 'chart-column',
      style: 'far'
    }
  },
  {
    type: 'pie',
    label: 'Pie - Frequency of a Choice Field',
    icon: {
      icon: 'chart-pie',
      style: 'far'
    }
  },
  {
    type: 'frequency',
    label: 'Line - Frequency of Entries over Time (per User)',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  },
  {
    type: 'line',
    label: 'Line - Number Field Values over Time',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  },
  {
    type: 'lineChoice',
    label: 'Line - Frequency of Choice Field over Time',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  }
  /** TODO: Enable this once we have the functionality implementation for this
   * {
    type: 'basic',
    label: 'Basic Statistical Analysis of a Number Field',
    icon: {
      icon: 'table',
      style: 'far'
    }
  } */
];

export const VueTelInputDefaultConfig = {
  mode: 'international',
  defaultCountry: 'US',
  autoFormat: true,
  autoDefaultCountry: false,
  validCharactersOnly: true
};
